export default "__VITE_ASSET__BhjOYxdf__"